import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";



const RequestDemo = () => {
  const { handleSubmit } = useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {

  }, []);

  const [registration, setRegistration] = useState({
    id: "",
    fist_name: "",
    last_name: "",
    company: "",
    title: "",
    website: "",
    country: "",
    phone: "",
    email: "",
    w3review: "",
  });
  const [intrest, setIntrest] = useState([]);
  const handleInputs = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const checked = e.target.checked;
    if (checked) {
      setIntrest([...intrest, Boolean(checked)]);
    } else {
      setIntrest(intrest.filter((e) => e !== Boolean(checked)));
    }
    setRegistration({ ...registration, [name]: value });
  };

  const onSubmit = async () => {
    const {
      key: id = new Date().toString(),
      fist_name,
      last_name,
      company,
      title,
      website,
      country,
      phone,
      email,
      w3review,
    } = registration;
    const [oems, pms, capital_raising, brokerage_custody_service, decentralized_finance, staking] = intrest;
    const userData = {
      id,
      fist_name,
      last_name,
      company,
      title,
      website,
      country,
      phone,
      email,
      w3review,
      oems,
      pms,
      capital_raising,
      brokerage_custody_service,
      decentralized_finance,
      staking,
    };
    await PostData(userData);
  };

  const PostData = async (data) => {

    setLoading(true);
    try {
      const response = await fetch('https://wy5ak8xlh4.execute-api.ap-south-1.amazonaws.com/items', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        window.alert("Form has been submitted sucessfully", data);
        setRegistration({
          id: "",
          fist_name: "",
          last_name: "",
          company: "",
          title: "",
          website: "",
          country: "",
          phone: "",
          email: "",
          w3review: "",
        });
      } else {
        const errorData = await response.json();
        window.alert(`Error: ${errorData.error}`);
      }

    } catch (error) {
      window.alert("Error submitting form:", error);
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }

  };

  return (
    <>
      <div className="top-box">
        <div className="section">
          <section className="wrapper-demo">
            <div className="form-container">
              <form
                className="form"
                method="POST"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="two-inputs">
                  <div className="solve-margin">
                    <label htmlFor="fist_name">First name *</label>

                    <input
                      type="text"
                      id="fist_name"
                      name="fist_name"
                      value={registration.fist_name}
                      onChange={handleInputs}
                      required
                    />
                  </div>
                  <div className="sec-div-margin">
                    <label htmlFor="last_name" >
                      Last name *
                    </label>

                    <input
                      type="text"

                      id="last_name"
                      name="last_name"
                      value={registration.last_name}
                      onChange={handleInputs}
                      required
                    />
                  </div>
                </div>

                <div className="two-inputs">
                  <div className="solve-margin">
                    <label htmlFor="company">Company *</label>

                    <input
                      className="full-input"
                      type="text"
                      id="company"
                      name="company"
                      value={registration.company}
                      onChange={handleInputs}
                      required
                    />
                  </div>

                  <div className="sec-div-margin">
                    <label htmlFor="title" >
                      Title
                    </label>

                    <input

                      className="full-input"
                      type="text"
                      id="title"
                      name="title"
                      value={registration.title}
                      onChange={handleInputs}
                    />
                  </div>
                </div>

                <div className="two-inputs">
                  <div className="solve-margin">
                    <label htmlFor="website">Website</label>

                    <input
                      className="full-input"
                      type="text"
                      id="website"
                      name="website"
                      value={registration.website}
                      onChange={handleInputs}
                    />
                  </div>
                  <div className="sec-div-margin">
                    <label htmlFor="country">
                      Country *
                    </label>

                    <input

                      className="full-input"
                      type="text"
                      id="country"
                      name="country"
                      value={registration.country}
                      onChange={handleInputs}
                      required
                    />
                  </div>
                </div>

                <div className="two-inputs">
                  <div className="solve-margin">
                    <label htmlFor="phone">Phone *</label>

                    <input
                      type="text"
                      id="phone"
                      name="phone"
                      value={registration.phone}
                      onChange={handleInputs}
                      required
                    />
                  </div>
                  <div className="sec-div-margin">
                    <label htmlFor="email">
                      Email *
                    </label>

                    <input
                      type="text"

                      id="email"
                      name="email"
                      value={registration.email}
                      onChange={handleInputs}
                      required
                    />
                  </div>
                </div>

                <div className="send-msg-flex">
                  <div className="checkout-form">
                    <div className="checkbox-container browsers">
                      <label className="checkbox-heading" htmlFor="interest">
                        Areas Interest *
                      </label>

                      <div
                        className="checlbox-inner-container"
                        style={{ width: "max-content" }}
                      >
                        <div className="checkbox-inner-container">
                          <input
                            className="checkbox"
                            type="checkbox"
                            id="oems"
                            name="oems"
                            onChange={handleInputs}
                          />
                          <label className="checkbox-label" htmlFor="OEMS">
                            Order &amp; Execution Managment System
                          </label>
                        </div>
                        <div className="checkbox-inner-container">
                          <input
                            className="checkbox"
                            type="checkbox"
                            id="pms"
                            name="pms"
                            onChange={handleInputs}
                          />
                          <label className="checkbox-label" htmlFor="PMS">
                            Portfolio Managment System
                          </label>
                        </div>
                        <div className="checkbox-inner-container">
                          <input
                            className="checkbox"
                            type="checkbox"
                            id="capital_raising"
                            name="capital_raising"
                            onChange={handleInputs}
                          />
                          <label className="checkbox-label" htmlFor="Capital">
                            Capital Raising
                          </label>
                        </div>
                        <div className="checkbox-inner-container">
                          <input
                            className="checkbox"
                            type="checkbox"
                            id="brokerage_custody_service"
                            name="brokerage_custody_service"
                            onChange={handleInputs}
                          />
                          <label className="checkbox-label" htmlFor="Brokerage">
                            Brokerage & Custody Service
                          </label>
                        </div>
                        <div className="checkbox-inner-container">
                          <input
                            className="checkbox"
                            type="checkbox"
                            id="decentralized_finance"
                            name="decentralized_finance"
                            onChange={handleInputs}
                          />
                          <label className="checkbox-label" htmlFor="Brokerage">
                            Decentralized Finance
                          </label>
                        </div>
                        <div className="checkbox-inner-container">
                          <input
                            className="checkbox"
                            type="checkbox"
                            id="staking"
                            name="staking"
                            onChange={handleInputs}
                          />
                          <label className="checkbox-label" htmlFor="Brokerage">
                            Staking
                          </label>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div className="send-msg">

                    <section>
                      <div className="message-container">
                        <label htmlFor="message">Send us a message</label>
                        <textarea
                          className="text-area-input"
                          id="w3review"
                          name="w3review"
                          value={registration.w3review}
                          onChange={handleInputs}
                          rows="6"
                          cols="50"
                          placeholder="Type your message here..."
                        >
                          Type your message
                        </textarea>
                      </div>
                    </section>

                  </div>
                </div>

                <div className="submit-req">
                  <button type="submit" style={{ cursor: "pointer" }}>
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default RequestDemo;
